import Vue from 'vue';
import VueI18n from 'vue-i18n';

import { en, es, fr } from 'vuetify/lib/locale';

import * as enLocale from '../locales/en.json';
import * as esLocale from '../locales/es.json';
import * as frLocale from '../locales/fr.json';

Vue.use(VueI18n);

const messages = {
  en: {
    $vuetify: { ...en },
    ...enLocale.default,
  },
  es: {
    $vuetify: { ...es },
    ...esLocale.default,
  },
  fr: {
    $vuetify: { ...fr },
    ...frLocale.default,
  },
};

export default new VueI18n({
  locale: 'en', // set locale
  fallbackLocale: 'en',
  messages, // set locale messages
});
